function minimap(){

}

minimap()

export {minimap}